import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AlumniConnectComponent} from "./alumni-connect.component";
import {OverviewComponent} from "./overview/overview.component";
import {AlumniOfficeContactsComponent} from "./alumni-office-contacts/alumni-office-contacts.component";
import {StudentDatabaseComponent} from "./student-database/student-database.component";

const routes: Routes = [
    { path: 'connect', component: AlumniConnectComponent},
    { path: 'overview', component: OverviewComponent},
    { path: 'office-contacts', component: AlumniOfficeContactsComponent},
    { path: 'student-database', component: StudentDatabaseComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlumniConnectRoutingModule { }
